import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { saveScenarioOutputApi } from '../scenarioApi';
import { useTranslation } from 'react-i18next';
import LoadingButton from '../../../components/LoadingButton';
import { useHistory } from 'react-router-dom';

const SaveScenarioModal = ({
  show,
  onClose,
  orgId,
  model,
  inputs,
  baseline,
  result,
  handleSubmit,
}) => {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const onSave = async (values) => {
    if (!result) return;
    if (!name.trim()) {
      toast.error(t('Scenario name is required'));
      return;
    }
    try {
      setLoading(true);
      await saveScenarioOutputApi(orgId, {
        name,
        model,
        inputs: {
          ...inputs,
          values,
        },
        baseline,
        result,
      });
      onClose(true);
      setTimeout(() => {
        history.push('/model-scenarios?tab=saved');
        toast.success(t('Scenario saved successfully'));
      }, 100);
    } catch (e) {
      toast.error(t('Failed to save scenario'));
    } finally {
      setLoading(false);
    }
  };
  const handleSave = handleSubmit(onSave);

  return (
    <Modal show={show} onHide={() => onClose(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('Save Scenario')}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group>
          <Form.Label>{t('Scenario Name')}</Form.Label>
          <Form.Control
            placeholder={t('Enter scenario name...')}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <LoadingButton isLoading={loading} />
        <Button variant="outline-secondary" onClick={() => onClose(false)}>
          {t('Cancel')}
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={loading || !String(name).trim()}
        >
          {t('Save')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SaveScenarioModal;
